import { service } from "@/api/service ";
import { toastError } from "@/components/custom/Toast";

const state = {
  fatoraPaymentResult: [],
  openDialog: false,
  paymentMethodInFatora: "",
};
const getters = {
  fatoraResultGet: (state) => state.fatoraPaymentResult,
  openDialogGet: (state) => state.openDialog,
  paymentMethodInFatoraGet: (state) => state.paymentMethodInFatora,
};
const actions = {
  fatoraPayment({ commit }, payLoad) {
    service.postFun(payLoad, `user/create_payment`).then(
      (obj) => {
        console.log(obj);
        commit("fatoraPayment", obj.data);
        if (obj.data.method === "fatora") {
          window.location.replace(obj.data.url);
        } else {
          commit("openDialogMut", true);
          commit("paymentMethodMutInFatora", "fatora");
        }
      },
      (error) => {
        toastError(error);
      }
    );
  },
};
const mutations = {
  fatoraPayment(state, result) {
    state.fatoraPaymentResult = result;
  },
  openDialogMut(state, payload) {
    state.openDialog = payload;
  },
  paymentMethodMutInFatora(state, payload) {
    state.paymentMethodInFatora = payload;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
